import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const menuFilterListSuccess = (state, menuFilterList) => {
  state.menuFilterList = menuFilterList;
};

const restrictionIntervalListSuccess = (state, restrictionIntervalList) => {
  state.restrictionIntervalList = restrictionIntervalList;
};

const setDateRangeFilter = (state, dateRange) => {
  state.dateRangeFilter = dateRange;
};

const setMenuGuidFilter = (state, menuGuid) => {
  state.menuGuidFilter = menuGuid;
};

const setSectionGuidFilter = (state, sectionGuid) => {
  state.sectionGuidFilter = sectionGuid;
};

const setSaleRateFilter = (state, saleRate) => {
  state.saleRateFilter = saleRate;
};

const resetData = (state) => {
  state.menuFilterList = [];
  state.restrictionIntervalList = null;
  state.dateRangeFilter = null;
  state.menuGuidFilter = null;
  state.sectionGuidFilter = '';
  state.saleRateFilter = null;
  state.undoBuffer = [];
  state.undoBufferLength = 3;
};

const undoClear = (state) => {
  state.undoBuffer = [];
};

const undoBufferLengthModify = (state, newLength) => {
  state.undoBufferLength = newLength;
  while (state.undoBuffer.length > state.undoBufferLength) {
    state.undoBuffer.pop();
  }
};

const undoPop = (state) => {
  state.undoBuffer.shift();
};

const undoPush = (state, payload) => {
  state.undoBuffer.unshift(payload);
  if (state.undoBuffer.length > state.undoBufferLength) {
    state.undoBuffer.pop();
  }
};

export const mutations = {
  [MutationTypes.MENU_FILTER_LIST_SUCCESS]: menuFilterListSuccess,
  [MutationTypes.RESTRICTION_INTERVAL_LIST_SUCCESS]: restrictionIntervalListSuccess,
  [MutationTypes.UNDO_CLEAR]: undoClear,
  [MutationTypes.UNDO_POP]: undoPop,
  [MutationTypes.UNDO_PUSH]: undoPush,
  [MutationTypes.UNDO_BUFFER_LENGTH_MODIFY]: undoBufferLengthModify,
  [RESET_POINT_OF_SALE_STATE]: resetData,
  [MutationTypes.SET_DATE_RANGE_FILTER]: setDateRangeFilter,
  [MutationTypes.SET_MENU_GUID_FILTER]: setMenuGuidFilter,
  [MutationTypes.SET_SECTION_GUID_FILTER]: setSectionGuidFilter,
  [MutationTypes.SET_SALE_RATE_FILTER]: setSaleRateFilter
};
